const rankingItems = [
  {
    rank: 1,
    title: '顶流艺人深夜密会实锤照片流出',
    heat: '1,280万',
    trend: 'up',
    change: '+320万',
  },
  {
    rank: 2,
    title: '知名企业财务造假内部文件泄露',
    heat: '960万',
    trend: 'up',
    change: '+180万',
  },
  {
    rank: 3,
    title: '头部带货主播虚假宣传集体维权',
    heat: '850万',
    trend: 'up',
    change: '+95万',
  },
  {
    rank: 4,
    title: '影视公司派系斗争高管接连请辞',
    heat: '720万',
    trend: 'stable',
    change: '+12万',
  },
  {
    rank: 5,
    title: '国际赛事裁判受贿多国选手举报',
    heat: '670万',
    trend: 'up',
    change: '+240万',
  },
  {
    rank: 6,
    title: '科技巨头CEO内部邮件安全隐患曝光',
    heat: '580万',
    trend: 'new',
    change: '新上榜',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热搜榜单
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            暗网吃瓜实时热搜榜单，基于全网讨论热度与阅读量综合排序
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 border border-background-300/30 rounded-xl overflow-hidden">
            {rankingItems.map((item, i) => (
              <a
                key={i}
                href="#cards"
                className={`flex items-center gap-4 p-4 hover:bg-background-200/50 transition-colors cursor-pointer ${
                  i < rankingItems.length - 1 ? 'border-b border-background-300/20' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50 font-bold'
                    : 'bg-background-200 text-foreground-500'
                } text-sm`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-700 truncate group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </p>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-xs font-medium text-accent-400 whitespace-nowrap">{item.heat}</span>
                  <span className={`text-xs whitespace-nowrap ${
                    item.trend === 'up'
                      ? 'text-primary-400'
                      : item.trend === 'new'
                      ? 'text-accent-400'
                      : 'text-foreground-500'
                  }`}>
                    {item.change}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}